export default __webpack_public_path__ + "895d7b9564b752831344eabcaaf17d41.svg";